import { fetchWithCache, getCachedData } from "../services/apiService";

export const propertyById = async ({ setProperties }, id) => {
  // Show cached data immediately if available
  const cached = getCachedData("/api/property/propertyById", { id });
  if (cached) {
    setProperties(cached[0]);
    return cached[0];
  }

  try {
    // do not log request details in production
    const data = await fetchWithCache(
      "/api/property/propertyById",
      {
        method: "POST",
        body: { id },
        retries: 2,
        timeout: 10000,
      },
      true
    );
    // do not log response details in production
    setProperties(data[0]);
    return data[0];
  } catch (error) {
    if (process.env.NODE_ENV !== "production") {
}
    if (!cached) {
      setProperties(null);
    }
    return null;
  }
};
